import {
  CommonIncidentId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import { PocketIncidents, PocketIncidentsConfig } from '../../../configuration'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: RugbyLeagueIncidentId.Timeout,
    title: 'Timeout',
  },
  {
    incidentId: RugbyLeagueIncidentId.RefereeReview,
    title: 'Ref. review',
  },
  {
    incidentId: RugbyLeagueIncidentId.Injury,
    title: 'Injury',
  },
  {
    incidentId: RugbyLeagueIncidentId.MedicalTimeout,
    title: 'Med. timeout',
  },
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'Tech. problem',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: RugbyLeagueIncidentId.BreakDuringGame,
    title: 'Break during the game',
  },
  {
    incidentId: RugbyLeagueIncidentId.WaterBreak,
    title: 'Water break',
  },
]

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap: new Map(),
}
